<template>
  <div slot="reference" v-drag class="float-wrapper service-float-popover" :class="{ isZH: ['zh-CN', 'zh-HK'].includes(language) }" @click="linkUrl">
    <img class="icon" src="./imgs/service_online.svg" alt="">
    <span class="service-text" v-html="$t('standard.onlineService')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDictionaryApi } from '@/api/common/public'
let thisRef = null
// 兜底：数据字典未配置或取不到时的默认客服链接
const DEFAULT_SERVICE_URL = 'https://kefu.sf.global/webim/im.html?configId=27ea00b1-c9f2-4a6e-b2a9-a396f1ae7829'
// 数据字典 key：该组件仅用于马来 OS 站，用 OS_ 前缀与 SG 域已占用的 serviceUrl/MY 配置区分
const DICT_NAME = 'serviceUrl'
const DICT_KEY = 'OSMY'
export default {
  directives: {
    drag: (el) => {
      const dragBox = el
      let disX
      let disY
      dragBox.onmousedown = e => {
        disX = e.clientX - dragBox.offsetLeft
        disY = e.clientY - dragBox.offsetTop
      }
      document.onmousemove = e => {
        if (!disX && !disY) return
        const left = e.clientX - disX
        const top = e.clientY - disY
        dragBox.style.left = left + 'px'
        dragBox.style.top = top + 'px'
        thisRef && (thisRef.isDrag = true)
      }
      document.onmouseup = e => {
        // document.onmousemove = null
        // document.onmouseup = null
        if (thisRef && thisRef.isDrag) {
          e.stopPropagation()
          e.preventDefault()
        }
        disX = null
        disY = null
        thisRef && (thisRef.isDrag = false)
      }
    }
  },
  data() {
    return {
      el: null,
      visible: false,
      isDrag: false,
      serviceUrl: ''
    }
  },
  computed: {
    ...mapGetters(['siteCode', 'language', 'floatServiceClickStatus']),
    isJPSite() {
      return this.siteCode === 'JP'
    }
  },
  watch: {
    'siteCode'() {
      this.fetchServiceUrl()
    },
    'language'() {
      this.fetchServiceUrl()
    }
  },
  mounted() {
    thisRef = this
    this.fetchServiceUrl()
  },
  methods: {
    // 从后端基础数据字典取客服链接：名称=serviceUrl，key=OSMY（与 SG 域共用的 MY 配置区分开）
    // 后台配置：名称=serviceUrl，字典key=OSMY，按语言维度各配一条
    fetchServiceUrl() {
      if (!this.siteCode) return
      getDictionaryApi({
        name: DICT_NAME,
        key: DICT_KEY,
        lang: this.language,
        enDefaultFlag: false
      }).then(response => {
        if (response && response.data) {
          this.serviceUrl = response?.data?.[DICT_KEY] || ''
        }
      }).catch(() => {})
    },
    handleClick() {
      this.visible = !this.visible
    },
    linkUrl() {
      this.visible = !this.visible
      // 优先取数据字典配置，未配置时兜底硬编码链接
      window.open(this.serviceUrl || DEFAULT_SERVICE_URL)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.float-wrapper {
  display: flex;
    align-items: center;
    justify-content: center;
  position: fixed;
  width: 48px;
  height: 100px;
  padding-top: 48px;
  padding-bottom: 16px;
  right: 16px;
  bottom: 120px;
  background: $color01;
  border-radius: 24px;
  box-shadow: 0 6px 10px -10px rgba(0,0,0,0.10), 0 3px 12px 0 rgba(0,0,0,0.06);
  z-index: 201;
  user-select: none;
  &.isZH {
    height: 136px;
  }
  .icon {
    position: absolute;
    width: 36px;
    height: 36px;
    left: 6px;
    top: 6px;
    pointer-events: none;
  }
  .service-text {
    display: block;
    color: #FF3A3A;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    line-height: 18px;
  }
}

.content {
  a {
    width: 100%;
    display: flex;
    align-items: center;
    color: $color02;
  }
  > div {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 8px;
    margin: 0 0 16px 0;
    border-radius: 6px;
    font-size: 16px;
    color: $color02;
    font-weight: 500;

    &.flex-start {
      align-items: flex-start;
    }
    &::before {
      position: absolute;
      top: -8px;
      left: 0;
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      background: $color04;
    }

    &:first-child {
      &::before {
        display: none;
      }
    }

    &:last-child {
      margin-bottom: 8px;
    }

    &:hover {
      cursor: pointer;
      background: rgba(255,142,155,0.16);
    }

    p {
      margin: 0;
      padding: 3px 0;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
.link-url {
  width: 100%;
}
</style>

<style>
.service-float-popover {
  padding: 8px 12px 0;
  border: none;
  z-index: 201 !important;
}
</style>
